import { CSSProperties } from 'react';
import styled from 'styled-components';
import { CollectionCard as CollectionCardComponent } from 'components/Shared/CollectionCard';
import { CollectionCardSkeleton as CollectionCardSkeletonComponent } from 'components/Shared/CollectionCard/Skeleton';
import { numericToPx } from 'utils/styles/numeric-to-px';

export const CollectionCard = styled(CollectionCardComponent)`
  &&& {
    margin-right: 8px;
  }
`;

export const CollectionCardSkeleton = styled(CollectionCardSkeletonComponent)`
  &&& {
    margin-right: 8px;
  }
`;

export const EmptyCollectionsSlider = styled.div<{
  $height?: CSSProperties['height'];
}>`
  height: ${({ $height }) => numericToPx($height) || '100%'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--v3-text-color-secondary);
`;
